import { render, staticRenderFns } from "./LandingBabyRegistryEN.vue?vue&type=template&id=1757ec3e&scoped=true"
import script from "./LandingBabyRegistryEN.vue?vue&type=script&lang=js"
export * from "./LandingBabyRegistryEN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1757ec3e",
  null
  
)

export default component.exports